import { FC } from 'react';
import { styled } from 'styled-components';
import { Alert } from '@/Icons';
import { flexPos } from '@/assets/styles/mixin';
import { $fontSize, $height, phoneSize } from '@/assets/styles/mediaSize';
import { useLang } from '@/locales/useLang';

const NetworkWrap = styled.div`
  ${flexPos('center')}
  width: 100%;
  ${$height('80rem', '40rem')}
  ${$fontSize('24rem', '12rem')}
  background-color: #fff0f0;

  flex: 0 0 80rem;

  @media (min-width: ${phoneSize}) {
    flex: 0 0 40rem;
  }
`;

const Network: FC<{}> = () => {
  const $t = useLang();

  return (
    <NetworkWrap>
      <Alert className="w-28 h-28 md:w-14 md:h-14" />
      <div className="ml-8 text-#979797">{$t('chat_session_status_9')}</div>
    </NetworkWrap>
  );
};

export default Network;
